export const getRoomShortCode = (
  categoryName?: string | null,
): string | null =>
  categoryName
    ? categoryName
        .split(" ")
        .filter(Boolean)
        .slice(0, 3)
        .map((word) => word.charAt(0))
        .join("")
        .toUpperCase()
    : null;
